import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router';
import { useRouteMatch } from 'react-router-dom';
import PageLoader from '@jumbo/components/PageComponents/PageLoader';

const CatiAdmin = () => {
  const match = useRouteMatch();

  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Route path={`${match.url}/fw-progress`} component={lazy(() => import('./FWProgress'))} />
        <Route path={`${match.url}/export-raw-data`} component={lazy(() => import('./ExportRawData'))} />
        <Route path={`${match.url}/qc-data`} component={lazy(() => import('./QCData'))} />

        <Route component={lazy(() => import('../../error/Error404'))} />
      </Switch>
    </Suspense>
  );
};

export default CatiAdmin;
